import {Button, Card, Form, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    if(this.props.title === 'CREATE') {
      this.props.fetchActivitySno();
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, activities} = this.props;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {
              title === 'EDIT' ? <Form.Item key={'tpwNo'} label = {'TPW No'}>
                <Select style = {{width: '190px'}} showArrow={false} disabled={true} value={(data && data.tpwNo) ? data.tpwNo : ''} />
              </Form.Item> : ''
            }
            {
              Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array') {
                return <Form.Item key={item}
                           label={sanitizeFieldName(filters[item].options.label ? filters[item].options.label : item)}>
                  {getFieldDecorator(item, {
                    rules: [{
                      required: filters[item].options.required ? filters[item].options.required : '',
                      message: `${filters[item].options.label ? filters[item].options.label : item} is required!`
                    }],
                    initialValue: (title === 'EDIT') ? (data && data.activitySerialNo && data.activitySerialNo.length) ? data.activitySerialNo : [] : [],
                  })(<Select
                    mode="multiple"
                    allowClear
                    showArrow={true}
                    placeholder={`Please Select ${sanitizeFieldName(filters[item].field)}`}
                    disabled={title === 'EDIT' && filters[item].options.disabledOnEdit}
                  >
                    {activities && activities.map(item => <Select.Option key={item.activitySerialNo}>{item.activitySerialNo}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>
                //return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>
              } else {
                return getFormFieldByType(filters, item, getFieldDecorator, data, {resource, title})
              }
            })}
            {
              title === 'EDIT' ?
                <Form.Item key={'status'} label={'Status'}>
                  <Select style = {{width: '190px'}} showArrow={false} disabled={true} value={(data && data.status) ? data.status : ''} />
                </Form.Item> : ''
            }
            {
              title === 'EDIT' ?
                <Form.Item key={'closureDate'} label={'Closure Date'}>
                  <Select style = {{width: '190px'}} showArrow={false} disabled={true} value={(data && data.closureDate) ? data.closureDate : ''}/>

                </Form.Item> : ''
            }
            {
              title === 'CREATE' ?
                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>CREATE</Button>
                </Form.Item> : ''
            }
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
